import { useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { useHistory } from 'src/lib/hooks';
import { ROUTE_PARAMS } from 'src/routes';

export const useReactToLocationViewId = ({ handleSeeMoreClick, id, ref }) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get(ROUTE_PARAMS.talkingPointsViewId) !== id) {
      return;
    }
    ref.current?.scrollIntoView();
    handleSeeMoreClick();
    searchParams.delete(ROUTE_PARAMS.talkingPointsViewId);
    history.replace({
      search: searchParams.toString(),
    });
  }, [history, handleSeeMoreClick, id, location, ref]);
};
